<div class="ibox detailed-view-ibox" *ngIf="directoryService.showDetailedView && data">
    <div class="detailed-view-header">
        <a *ngIf="data.suiteNumber" [routerLink]="['/directory/item/' + data.suiteId + '/bike-racks/' + data.id]">
			<span class="suite-name m-r-sm mtv-primary-color">{{data.suiteNumber}}</span>
        </a>
        <span class="building-name">{{data.buildingName || 'Create' + title}}</span>
        <span class="close-detailed-view" (click)="directoryService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
        <div class="detailed-view__more-info directory-detailed-view-content m-t-md">
            <form #form="ngForm" (ngSubmit)="onSubmit(form)" [ngClass]="{'ng-submitted': form.submitted}">
                <input type="hidden" name="id" [ngModel]="data.id">

                <!-- * rackNumber * -->
                <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'rackNumber', true)">
                    <div class="dv-label col-sm-4 strong">Rack #</div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.rackNumber.editMode">
                        <span>{{data.rackNumber || '-'}}</span>
                        <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'rackNumber', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.rackNumber.editMode">
                        <input class="form-control" name="rackNumber" [ngModel]="data.rackNumber" required maxlength="255"
                               (keyup.enter)="applyChanges(data, form, 'rackNumber')">
                        <button type="button" (click)="applyChanges(data, form, 'rackNumber')"   ><i class="fa fa-check"></i></button>
                        <button type="button" (click)="setEditModeFor(data, 'rackNumber', false)"><i class="fa fa-times"></i></button>
                    </div>
                </div>

                <!-- * rentedOut * -->
                <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'rentedOut', true)">
                    <div class="dv-label col-sm-4 strong">Rented Out: </div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.rentedOut.editMode">
                        <i *ngIf="data.rentedOut == 1" class="icon-check"></i>
                        <i *ngIf="data.rentedOut == 0" class="icon-close"></i>
                        <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'rentedOut', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.rentedOut.editMode">
                        <select class="form-control" name="rentedOut" [ngModel]="data.rentedOut">
                            <option [value]="1">Yes</option>
                            <option [value]="0">No</option>
                        </select>
                        <button type="button" (click)="applyChanges(data, form, 'rentedOut')"   ><i class="fa fa-check"></i></button>
                        <button type="button" (click)="setEditModeFor(data, 'rentedOut', false)"><i class="fa fa-times"></i></button>
                    </div>
                </div>

                <!--** building ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToBuilding', true)">
                    <div class="dv-label col-sm-4 strong">Building</div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.rentedToBuilding.editMode">
                        <span>{{data.extendedRentedTo.buildingName || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToBuilding', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>
                    <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.rentedToBuilding.editMode">
                        <select class="form-control"
                                name="building"
                                [ngModel]="data.extendedRentedTo.building"
                                (change)="changeBuilding($event.target.value, form)">
                            <option value="" hidden></option>
                            <option *ngFor="let build of directoryService.buildings"
                                    [value]="build.id">{{build.name}}
                            </option>
                        </select>
                        <button type="button" (click)="applyChanges(data, form, 'rentedToBuilding')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(data, 'rentedToBuilding', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <!--** rentedToSuite ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToSuite', true)">
                    <div class="dv-label col-sm-4">
                        <label>Unit</label>
                    </div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.rentedToSuite.editMode">
                        <span>{{data.extendedRentedTo.suiteNumber || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToSuite', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>
                    <div class="dv-value-edit col-sm-8" style="display: block;" *ngIf="data.formFields.rentedToSuite.editMode">
                        <div style="display: flex; width: 100%;">
                            <search-select [ngModel]="data.extendedRentedTo.suite"
                                           name="suite"
                                           style="height: 26px;"
                                           (ngModelChange)="changeUnit($event, form)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <button type="button" (click)="applyChanges(data, form, 'rentedToSuite')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'rentedToSuite', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <input *ngIf="form.value.suite === 0"
                               class="form-control"
                               [ngModel]="data.extendedRentedTo.suiteNumber"
                               name="suiteNumber"
                               placeholder="Other Unit Number"
                               maxlength="255" required>
                        <spinner [spinnerShow]="form.value.building && !suites.length"></spinner>

                    </div>
                </div>

                <!--** rentedToSuiteUser ** -->
                <div class="row m-b-xs"
                     *ngIf="data.rentedOut == 1"
                     (dblclick)="setEditModeFor(data, 'rentedToSuiteUser', true)">
                    <div class="dv-label col-sm-4">
                        <label>Resident</label>
                    </div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.rentedToSuiteUser.editMode">
                        <span>{{data.extendedRentedTo.suiteUserName || '-'}}</span>
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'rentedToSuiteUser', true)"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>

                    <div class="dv-value-edit col-sm-8" style="display: block;" *ngIf="data.formFields.rentedToSuiteUser.editMode">
                        <div style="display: flex; width: 100%;">
                            <select class="form-control"
                                    (change)="changeResident($event.target.value)"
                                    [ngModel]="data.extendedRentedTo.suiteUser"
                                    name="suiteUser"
                                    #residentSelect
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">
                                    {{resident.fullName}}
                                </option>
                            </select>
                            <button type="button" (click)="applyChanges(data, form, 'rentedToSuiteUser')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'rentedToSuiteUser', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <input *ngIf="residentSelect.value === '0'"
                               class="form-control"
                               placeholder="Other Resident Name"
                               [ngModel]="data.extendedRentedTo.suiteUserName"
                               name="suiteUserName"
                               maxlength="255" required>
                        <spinner [spinnerShow]="form.value.suite && !residents.length"></spinner>
                    </div>
                </div>

                <!-- * note * -->
                <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'note', true)">
                    <div class="dv-label col-sm-4 strong">Notes</div>
                    <div class="dv-value col-sm-8" *ngIf="!data.formFields.note.editMode">
                        <pre>{{data.note || '-'}}</pre>
                        <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'note', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value col-sm-8" *ngIf="data.formFields.note.editMode">
                        <textarea class="form-control" name="note" [ngModel]="data.note" maxlength="255">{{data.note}}</textarea>
                        <div class="m-t-xs apart-btns pull-right">
                            <button type="button" class="apply" (click)="applyChanges(data, form, 'note')"><i class="fa fa-check"></i></button>
                            <button type="button" class="reset" (click)="setEditModeFor(data, 'note', false)"><i class="fa fa-times"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <hr *ngIf="data.id && data.isCanDelete">

        <div class="btn-group dropup directory-actions" *ngIf="data.id && data.isCanDelete">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <li (click)="remove(data.id)"><a>Delete This {{title}}</a></li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/bike-rack-view/bike-rack-view.component.html